/* Native details remain usable without JavaScript; subject links also open them. */
(() => {
  const openGuide = hash => {
    if (!hash || !hash.startsWith('#article-')) return;
    const guide = document.getElementById(hash.slice(1));
    if (guide?.matches('details.cm-v20-guide')) guide.open = true;
  };
  openGuide(location.hash);
  window.addEventListener('hashchange', () => openGuide(location.hash));
  document.addEventListener('click', event => {
    const link = event.target.closest('.cm-v20-guide-nav a[href^="#article-"]');
    if (link) openGuide(link.hash);
  });
})();
